class Giftwrapping extends HTMLElement {
    

	constructor() {

	  	super();  

		this.pid = null;
		this.checkbox = this.querySelector('input[type="checkbox"]');	
		this.dataset.pid !== undefined ? this.pid = Number(this.dataset.pid) : null;
	  	this.debouncedOnChange = debounce((event) => { this.onChange(event) }, 300);
	  	this.addEventListener('change', this.debouncedOnChange.bind(this));

	  	this.checkWrapping();
	}
	

	async getCart() {
		const result = await fetch("/cart.json");
		if (result.status === 200) {
		    return result.json();
		}
		throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
	}


	async addItem(id, qty) {  
		const result = await fetch("/cart/add.json", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				id: id,
				quantity: qty
			})
		})		
		return result;
	}

	
	async removeItemByID(id) {
		const result = await fetch("/cart/change.json", {
		  method: "POST",
		  headers: {
			"Content-Type": "application/json",
			"Accept": "application/json"
		  },
		  body: JSON.stringify({
			'id': `${id}`,
			'quantity': 0
		  })
		});
		return result.json();
	}


	async findItemInCart(id){
		let findAttribute = await this.getCart();
		let thisID = id;
		let itemFound = findAttribute.items.filter(itm => itm.variant_id === thisID);  
		if(!itemFound.length) { return false } else { return [true,itemFound] }    
	}


	async setCartAttributes(attributes = {}) {
		const result = await fetch("/cart/update.json", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				attributes: attributes 
			})
		});    
		return result.json();
	}

	
	onChange(event) { 
		if(this.checkbox.checked){ 				
			if(this.pid != null) {			
				if(typeof(this.pid) == 'number' && this.pid != ''){ 
					(async () => { await this.addItem(this.pid, 1); this.renderCart() })()
				} else { this.style.display = 'none'; return }
			} else {
				let obj = { "SIMPLE_GIFTWRAP": "YES" };
				JSON.stringify(obj);
				(async () => { await this.setCartAttributes(obj); this.renderCart() })()
			}			
		} else {
			if(this.pid != null) {
				(async () => { await this.removeItemByID(this.pid); this.renderCart() })()  
			} else {
				let obj = { "SIMPLE_GIFTWRAP": "NO" };
				JSON.stringify(obj);
				(async () => { await this.setCartAttributes(obj ); this.renderCart() })()
			}
		}
	}
	
	
	getSectionsToRender() {
		return [
			{ id: 'cart-drawer', section: '#CartDrawer', selector: '.drawer-inner' }
		];
		
	}


	renderCart() {  
		this.getSectionsToRender().forEach((section) => {
			fetch(`/?section_id=${section.id}`)
				.then(response => response.text())
				.then((responseText) => {
					let html = responseText;
					let elementToReplace = document.querySelector(`${section.selector}`);
					let replaceWith = new DOMParser().parseFromString(html, 'text/html').body.querySelectorAll(`${section.selector} > *`); 
                    elementToReplace.innerHTML = ''
                    replaceWith.forEach((element) => { elementToReplace.appendChild(element) })	
				});     
		}); 	  
	}
 
 
	checkWrapping() {
		if(this.pid != null) {
			(async () => {  
				const wrapincart = await this.findItemInCart(this.pid);  
				wrapincart[0] == true ? this.checkbox.checked = true : this.checkbox.checked = false;
			})()
		} else {
			(async () => { 
				let findAttribute = await this.getCart();
				//console.log('findAttribute SIMPLE_GIFTWRAP', findAttribute)
				if(findAttribute.attributes.hasOwnProperty('SIMPLE_GIFTWRAP')) {
					findAttribute.attributes['SIMPLE_GIFTWRAP'] === "YES" ? this.checkbox.checked = true : this.checkbox.checked = false;
				} else {
					this.checkbox.checked = false;
				}
			})()
		}
	}

	
}
customElements.define('gift-wrapping', Giftwrapping);